import {useQuery} from 'react-query'
import {RentalEditModalForm} from './RentalEditModalForm'
// import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getRentalById} from '../core/_requests'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'

const RentalEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const dataresponse = {name:"demo"}
  const {
    isLoading,
    data: rental,
    error,
  } = useQuery(
    `${QUERIES.RENTALS_LIST}-rental-${itemIdForUpdate}`,
    () => {
      return getRentalById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        // setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )


  if (!itemIdForUpdate) {
    return <RentalEditModalForm isRentalLoading={false} rental={{id: undefined}} />
  }

  if (itemIdForUpdate) {
    return <RentalEditModalForm isRentalLoading={false} rental={dataresponse} />
  }

  return null
}

export {RentalEditModalFormWrapper}
